export default "__VITE_ASSET__Dvr7R5Gp__"